import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Notifications from '../../services/notifications';
import BasicModal from './BasicModal';
import FormInput from '../forms/FormInput';
import UserProp from '../propTypes/userProp';
import withCSRF from '../withCSRF';
import translate from '../translate';
import { compose } from '../../services/utilityFunctions';

function ResendEmailNotificationDialog({
  t,
  _csrf,
  onCancel,
  onSuccess,
  user,
}) {
  const { wasInvitedBy } = user || {};
  const wasInvitedByPhone = wasInvitedBy === 'phone';

  const [email, setEmail] = useState(wasInvitedByPhone ? '' : user.email);
  const [isLoading, setIsLoading] = useState(false);
  const resendInvitationEmail = async (userId, emailParam) => {
    try {
      setIsLoading(true);
      await axios.post(
        '/api/user/invited/resend',
        {
          email: emailParam,
          user: userId,
        },
        {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Organization',
            'X-CSRF-Token': _csrf,
            _csrf,
          },
        },
      );
      Notifications.showNotificationSuccess(
        t('success'),
        t('invitation_email_sent'),
      );

      onSuccess();
    } catch (err) {
      Notifications.showErrorFromRequest(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BasicModal
      id="inviteUser"
      saveMessage={t('confirm')}
      cancelMessage={t('cancel')}
      onClose={async isConfirm => {
        if (isConfirm) {
          if (wasInvitedByPhone && !email) {
            Notifications.showNotificationError(
              t('error'),
              t('user.resend.invite.description.phone'),
            );
            return;
          }

          await resendInvitationEmail(
            user._id,
            wasInvitedByPhone ? email : user.email,
          );
        } else {
          onCancel();
        }
      }}
      title={`${t('user.resend.invite.title')}${
        wasInvitedByPhone ? ` - ${user.phone}` : ''
      }`}
      isLoading={isLoading}
      disabled={isLoading}
    >
      {wasInvitedByPhone ? (
        <div>
          <p>{t('user.resend.invite.description.phone')}</p>
          <FormInput
            id="email"
            placeholder="Email"
            name="email"
            value={email}
            onChange={setEmail}
            inputProps={{ autoComplete: 'off' }}
          />
        </div>
      ) : (
        <p>{t('user.resend.invite.description.email')}</p>
      )}
    </BasicModal>
  );
}

ResendEmailNotificationDialog.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
};

export default compose(withCSRF, translate)(ResendEmailNotificationDialog);
